interface IconProps {
    className?: string | null;
    animationClassName?: string | null;
}

function HeaderPerson({ className = null, animationClassName = null }: IconProps) {
    return (
        <svg
            className={className || undefined}
            viewBox="0 0 304 304"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="152" cy="152" r="149.5" fill="#00A0EA" stroke="black" strokeWidth="5" />
            <path
                d="M180.76 90.5138H131.338C122.198 90.5138 114.791 97.8546 114.791 106.913V168.56C114.791 172.823 118.093 176.484 122.388 176.685C126.974 176.898 130.756 173.281 130.756 168.78V114.711C130.756 113.978 131.357 113.376 132.104 113.376C132.844 113.376 133.451 113.972 133.451 114.711V249.886C133.451 255.258 137.62 259.884 143.034 260.135C148.816 260.405 153.592 255.841 153.592 250.168V185.154C153.592 183.8 154.699 182.709 156.059 182.709C157.425 182.709 158.526 183.806 158.526 185.154V249.886C158.526 255.258 162.694 259.884 168.109 260.135C173.89 260.405 178.666 255.841 178.666 250.168V114.718C178.666 113.984 179.267 113.382 180.014 113.382C180.754 113.382 181.361 113.978 181.361 114.718V168.56C181.361 172.823 184.663 176.484 188.958 176.685C193.544 176.898 197.327 173.281 197.327 168.78V106.907C197.327 97.8483 189.919 90.5076 180.779 90.5076L180.76 90.5138Z"
                fill="black"
            />
            <path
                d="M163.473 84.5066C173.163 80.4421 177.694 69.3621 173.592 59.7588C169.491 50.1555 158.311 45.6654 148.621 49.7299C138.93 53.7944 134.399 64.8744 138.501 74.4777C142.602 84.081 153.782 88.5711 163.473 84.5066Z"
                fill="black"
            />
            <path
                d="M146.317 208.938C146.248 212.429 143.332 215.207 139.808 215.144L92.4867 214.229C88.9634 214.16 86.1612 211.276 86.2244 207.778L86.7178 182.841C86.7874 179.343 89.6972 176.572 93.2268 176.635L140.542 177.55C144.072 177.619 146.874 180.502 146.804 184L146.317 208.938Z"
                fill="black"
            />
            <path
                d="M116.612 191.423C109.363 191.285 103.575 185.743 103.708 179.073C103.841 172.403 109.838 167.094 117.087 167.231C124.336 167.369 130.124 172.911 129.991 179.581C129.858 186.251 123.855 191.561 116.612 191.423ZM117.049 169.093C110.837 168.974 105.695 173.469 105.581 179.111C105.473 184.753 110.432 189.442 116.644 189.561C122.856 189.68 127.998 185.185 128.112 179.543C128.226 173.895 123.261 169.212 117.049 169.087V169.093Z"
                fill="black"
                stroke="black"
                strokeWidth="4"
                strokeMiterlimit="10"
            />
        </svg>
    );
}

export default HeaderPerson;
